import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
@Pipe({
  standalone: false,
  name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {

  transform(value: any[], field: string, direction: 'asc' | 'desc' = 'asc'): unknown {
    return _.orderBy(value, [field], [direction]);
  }

}
